// extracted by mini-css-extract-plugin
export default {"box":"PrivateLayout_box__Fv6oM","sideBarOpen":"PrivateLayout_sideBarOpen__wsNxc","main":"PrivateLayout_main__EOD0k","animationRoll":"PrivateLayout_animationRoll__MqcIs"};